import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconBase } from 'library/styles/icon';
import { TransitionConfig } from 'library/constants/styles-config';
import { Container as Tag } from 'library/components/tag/styles';
import { Container as Color } from 'library/components/color/styles';
import { Paragraph, CardName } from 'library/styles/text';

const ImageOverlay = styled.div`
  position: absolute;
  width: 160px;
  height: 167px;
  border-radius: 8px;
  padding-top: 3px;
  background-image: linear-gradient(#2D3132, rgba(0, 0, 0, 0));
  background-size: 100% 54px;
  background-repeat: no-repeat;
  transition: opacity ${TransitionConfig}, background-color ${TransitionConfig};
  opacity: 0;
`;

const Icon = styled(IconBase)`
  color: ${Colors.shade05};

  &:hover {
    color: ${Colors.shade08};
  }

  &.icon-options-vertical {
    float: right;
  }
`;

const Image = styled.div`
  height: 167px;
  width: 100%;
  max-width: 160px;
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${({ url }) => url});
  filter: drop-shadow(0px 2px 8px rgba(45, 49, 50, 0.16));
`;

const DetailsContainer = styled.div`
  margin: 3px 25px 10px 25px;
`;

const Container = styled.div`
  width: 1315px;
  padding: 16px;
  //overflow: hidden;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
  transition: opacity 0.5s ease-out, background-color ${TransitionConfig};

  ${({ isDeleted }) => isDeleted && `    
    cursor: not-allowed !important;
    background-color: ${Colors.redLight1};
    border-radius: 8px;
    opacity: 0.25;

    ${ImageOverlay} {
       cursor: not-allowed !important;
       pointer-events: none;
    }
  `}

  ${({ isSelected }) => isSelected && `    
    ${ImageOverlay} {
      opacity: 1;
      background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
      background-color: rgba(${Colors.violetRgb}, 0.8);
    }
    
    ${Icon}.icon-check-inverse {
      color: ${Colors.shade08};      
    }
  `}
  
  ${({ isOpened }) => isOpened && `
    background-color: ${Colors.shade02};
    overflow: hidden;
    border-radius: 8px;
    color: ${Colors.shade08};
    max-width: 827px;

    ${DetailsContainer} {
    }
    h3 {
      color: inherit;
    }
    p {
      color: ${Colors.shade05};
    }
  `}

  img {
    display: block;
    max-width: 100%;
  }
  
  h3 {
    margin-top: 9px;
    margin-bottom: 3px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  //overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  height: 167px;
  &:hover {
    > div {
      opacity: 1;
    }
  }
  ${({ isOpened }) => isOpened && `
    // width: 260px;
  `}
  display: flex;

  ${Image} {
    border-radius: 8px;
  }

`;

const StyledColor = styled(Color)`
  margin-left: 2px;
  margin-right: 2px;
  width: 28px;
  background-color: ${({ color }) => color};
`;

const StyledTag = styled(Tag)`
  //word-break: break-all;
  //line-break: auto;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
  display: inline-block;
  //text-overflow: ellipsis;
  //white-space: nowrap;
`;

const CircleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 4px 0 0 0;
  
  ${StyledTag}, ${StyledColor} {
    display: inline-block !important;
  }

  ${StyledTag} {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    display: inline-block;
  }
}
`;

const TagsContainer = styled(CircleContainer)`
  align-items: baseline;

`;

const Circle = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 28px;
  margin-right: 4px;
  background: ${({ background }) => background};
`;

const TextWrapper = styled.div`
  padding: 12px 24px 0 24px;
  overflow: hidden;

  ${CardName} {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 21px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  ${Paragraph} {
    &:first-child {
      margin-top: 5px;
    }
  }
`;

export {
  Container,
  ImageWrapper,
  ImageOverlay,
  Icon,
  DetailsContainer,
  Image,
  CircleContainer,
  StyledTag,
  Circle,
  TextWrapper,
  StyledColor,
  TagsContainer,
};
